export default __webpack_public_path__ + "static/media/loadding.f986ff88.gif";